import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PlanCheckTracker } from "../../Types/PlanCheck/PlanCheckTrackerType";
import { getAllPlanChckTrackerList } from "../../Thunks/PlanCheckTrackerThunks";

interface PlanCheckTrackerSliceState {
  loader: boolean; // for refres pages and inital loadings
  planCheckTrackerList: PlanCheckTracker[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: PlanCheckTrackerSliceState = {
  loader: false,
  planCheckTrackerList: [],
  errorDisplay: '',
}

// set state valu for api response
const planCheckTrackerSlice = createSlice({
  name: 'planCheckTrackerSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllPlanChckTrackerList.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getAllPlanChckTrackerList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAllPlanChckTrackerList.fulfilled, (state, action: PayloadAction<PlanCheckTracker[]>) => {
        state.loader = false;
        state.planCheckTrackerList = action.payload;
      })
  }
})

export const { } = planCheckTrackerSlice.actions
export default planCheckTrackerSlice.reducer
